import { render } from "./ClientAwsMaintenance.vue?vue&type=template&id=2239ece4&scoped=true"
import script from "./ClientAwsMaintenance.vue?vue&type=script&lang=js"
export * from "./ClientAwsMaintenance.vue?vue&type=script&lang=js"

import "./ClientAwsMaintenance.vue?vue&type=style&index=0&id=2239ece4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2239ece4"]])

export default __exports__